import { Outlet, Link } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="auth-shell">
      <Link to="/" className="auth-brand">
        Bitxian
      </Link>
      <div className="auth-card">
        <Outlet />
      </div>
    </div>
  );
}
